import { twMerge } from 'tailwind-merge';
import {
  getCell3IgnorePaddingClasses,
  getCellVisibillityClasses,
  getTextAlignmentClasses,
  getTextAlignmentMarginClasses,
  shouldRenderPowerCellLabel,
  type Identifiers,
} from './power-cell-getters';
import { ButtonsContainer } from './buttons-container';
import LabelV2 from './label-v2';
import { type TextComponent } from './responsive-text';
import { type UseResponsiveBreakpoint } from '~/hooks/use-responsive-breakpoint';
import type { FeedEntry } from '~/services/layout/index';
import { getButtonsContainerPositionClasses } from './buttons-container/getters';
import { type UseFavoriteActionReturnType } from '~/hooks/use-favorite-action';
import type { SerializedStyles } from '@emotion/react';
import type { PopupMenuTriggerHandler } from '~/services/plugins/popup-menu/components/host/index.ts';

export function LabelWrapper({
  textLabelNames,
  assets,
  textLabels,
  textLabelsAlignment,
  textLabelClasses,
  defaultStyles,
  entryWebLink,
  identifiers,
  trackAnalyticsData,
  responsiveBreakpoint,
  entry,
  isLoading,
  isLabelHover,
  isPreferenceSelectorCellAndSelected,
  favoriteActionData,
  dynamicColors,
  onPopupMenuTrigger,
}: {
  textLabelNames: string[];
  assets: any;
  textLabels: any;
  textLabelsAlignment: any;
  textLabelClasses: Record<string, string>;
  defaultStyles: any;
  entryWebLink: string;
  identifiers: Identifiers;
  trackAnalyticsData: Function;
  responsiveBreakpoint: UseResponsiveBreakpoint;
  entry: FeedEntry;
  isLoading?: boolean;
  isLabelHover?: boolean;
  isPreferenceSelectorCellAndSelected?: boolean;
  favoriteActionData: UseFavoriteActionReturnType;
  dynamicColors?: {
    textLabel: SerializedStyles;
    buttonsContainer?: {
      buttonBorder: SerializedStyles;
      button: SerializedStyles;
    };
  };
  onPopupMenuTrigger?: PopupMenuTriggerHandler;
}) {
  return textLabelNames.map((textLabelName) => {
    const shouldRenderLabel: boolean = shouldRenderPowerCellLabel({
      textLabels,
      textLabelName,
    });

    return (
      <div
        className={twMerge(
          getButtonsContainerPositionClasses(assets, textLabelName),
          getCell3IgnorePaddingClasses(identifiers, 'label wrapper')
        )}
        key={textLabelName}
      >
        {shouldRenderLabel && (
          <div
            className={`w-fit ${getTextAlignmentMarginClasses({
              mobile: textLabelsAlignment.mobile[textLabelName],
              tablet: textLabelsAlignment.tablet[textLabelName],
              desktop: textLabelsAlignment.desktop[textLabelName],
              'large-desktop':
                textLabelsAlignment['large-desktop'][textLabelName],
            })} ${getCellVisibillityClasses({
              mobile: textLabels.mobile[textLabelName],
              tablet: textLabels.tablet[textLabelName],
              desktop: textLabels.desktop[textLabelName],
              'large-desktop': textLabels['large-desktop'][textLabelName],
            })}`}
          >
            <div
              className={`[&_*:not(.text-component-span-class)]:line-clamp-label-line-clamp [&_*:not(.text-component-span-class)]:leading-label-line-height ${getTextAlignmentClasses(
                {
                  mobile: textLabelsAlignment.mobile[textLabelName],
                  tablet: textLabelsAlignment.tablet[textLabelName],
                  desktop: textLabelsAlignment.desktop[textLabelName],
                  'large-desktop':
                    textLabelsAlignment['large-desktop'][textLabelName],
                }
              )}`}
            >
              <LabelV2
                responsiveText={{
                  mobile: textLabels.mobile[textLabelName],
                  tablet: textLabels.tablet[textLabelName],
                  desktop: textLabels.desktop[textLabelName],
                  'large-desktop': textLabels['large-desktop'][textLabelName],
                }}
                className={textLabelClasses[textLabelName]}
                componentTextLabelTypography={
                  defaultStyles[`${textLabelName}_typography`] as TextComponent
                }
                isLoading={isLoading}
                isLabelHover={isLabelHover}
                isPreferenceSelectorCellAndSelected={
                  isPreferenceSelectorCellAndSelected
                }
                dynamicColors={dynamicColors?.textLabel}
              />
            </div>
          </div>
        )}
        <ButtonsContainer
          assets={assets}
          textLabelKeyName={textLabelName}
          entryWebLink={entryWebLink}
          trackAnalyticsData={trackAnalyticsData}
          responsiveBreakpoint={responsiveBreakpoint}
          entry={entry}
          favoriteActionData={favoriteActionData}
          dynamicColors={dynamicColors?.buttonsContainer}
          onPopupMenuTrigger={onPopupMenuTrigger}
        />
      </div>
    );
  });
}
